import { useEffect, useRef } from "react";

const FORM_URL = "https://form.jotform.com/262923720186055";
const HANDLER_URL = "https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js";

export default function JotFormEmbed() {
  const iframeRef = useRef(null);

  useEffect(() => {
    const runHandler = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(
          "iframe[id='JotFormIFrame-262923720186055']",
          "https://form.jotform.com/"
        );
      }
    };

    let script = document.querySelector(`script[src="${HANDLER_URL}"]`);
    if (script) {
      runHandler();
    } else {
      script = document.createElement("script");
      script.src = HANDLER_URL;
      script.async = true;
      script.onload = runHandler;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="relative w-full overflow-hidden" data-testid="jotform-embed-wrapper">
      <iframe
        ref={iframeRef}
        id="JotFormIFrame-262923720186055"
        data-testid="jotform-intake-iframe"
        title="Shonta Solutions Property Intake Form"
        src={FORM_URL}
        allow="geolocation; microphone; camera; fullscreen; payment"
        frameBorder="0"
        scrolling="no"
        style={{ width: "100%", minHeight: 720, border: 0 }}
      />
      {/* Covers the JotForm branding footnote at the bottom of the embed */}
      <div
        className="absolute bottom-0 left-0 right-0 h-14 bg-white"
        aria-hidden="true"
        data-testid="jotform-branding-cover"
      />
    </div>
  );
}
